export default __webpack_public_path__ + "a26937227ccc910323980b7b9d263a43.png";